import { useBetslipContext } from '@cx-web/feature-betslip/context';

import type IBet from '../interfaces/IBet';
import styles from '../style/multi-betslip.module.css';

import BetslipBet from './bet';
import BookieSelection from './bookie-selection';
import BookieSelector from './bookie-selector';

// The selected-bets list inside the betslip drawer. Wrapped in a labelled <ul>
// so tests can scope listitem lookups. Full ARIA navigation contract for
// tests/AT lives at the top of ../betslip.tsx.
const MultiBetslip = (): JSX.Element => {
  const { betslip: bets, bookieOdds, selectedBookie } = useBetslipContext();

  const renderBets = () => {
    const ordered = bets
      .map(bet => ({
        bet,
        disabled: !!(selectedBookie && !selectedBookie.betIds?.includes(bet.betId)),
      }))
      .sort((a, b) => Number(a.disabled) - Number(b.disabled));

    return ordered.map(({ bet, disabled }, idx) => (
      <BetslipBet bet={bet as IBet} disabled={disabled} key={bet.betId} posInSet={idx + 1} setSize={ordered.length} />
    ));
  };

  const renderSelector = () => {
    if (bookieOdds.length > 1) return <BookieSelector />;
  };

  return (
    <div className={styles.multiBetslipWrapper}>
      <div className={styles.selectedBookie}>
        <div className={styles.bookie}>
          <BookieSelection selected selectedBookie={selectedBookie!} />
        </div>
      </div>

      <div className={styles.scrollWrapper}>
        <ul aria-label={`Selected bets (${bets.length})`} className={styles.betList}>
          {renderBets()}
        </ul>
        {renderSelector()}
      </div>
    </div>
  );
};

export default MultiBetslip;
